define("shared/components/shared/profile-categorization/rewards-steps/report/partial", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--m__b__xs u--text--light u--text--center">
    {{t (concat @prefix "industry_insights")}}
  </p>
  
  <a class="u--block u--text--center qa--categorize_back" {{on "click" (fn @clearSelectedCategory "rewards")}}>
    {{t "profile_categorization.categorize_form.change_selection"}}
  </a>
  
  <h2 class="tSC--card__title u--text--center">
    {{t (concat "profile_categorization.industries." @socialProfile.industry)}}
  </h2>
  
  <div class="tSC--result">
    <Shared::ProfileCategorization::RewardsSteps::Tab::HashtagUsage
      @industryHashtags={{@industryReportData.industryHashtags}}
      @isLoading={{@industryReportData.isLoading}}
      @sectionName={{@sectionName}}
      @showPartialRewards={{true}}
      @socialProfile={{@socialProfile}}
      @triggerSegmentEvent={{fn this.trackViewedIndustryComparison 2}}
    />
  </div>
  
  <Shared::Ui::Button
    @additional="block"
    @onClick={{fn @exitCategorization false}}
    @size="regular"
    class="qa--categorize_reports_exit"
  >
    {{#if @isModalFlow}}
      {{t "shared_words.done"}}
    {{else}}
      {{t "authorization.sign_up_success.finish_setup"}}
    {{/if}}
  </Shared::Ui::Button>
  */
  {
    "id": "lyVLDV7W",
    "block": "[[[10,2],[14,0,\"u--m__b__xs u--text--light u--text--center\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[[30,1],\"industry_insights\"],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[11,3],[24,0,\"u--block u--text--center qa--categorize_back\"],[4,[38,2],[\"click\",[28,[37,3],[[30,2],\"rewards\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"profile_categorization.categorize_form.change_selection\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"h2\"],[14,0,\"tSC--card__title u--text--center\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[\"profile_categorization.industries.\",[30,3,[\"industry\"]]],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tSC--result\"],[12],[1,\"\\n  \"],[8,[39,4],null,[[\"@industryHashtags\",\"@isLoading\",\"@sectionName\",\"@showPartialRewards\",\"@socialProfile\",\"@triggerSegmentEvent\"],[[30,4,[\"industryHashtags\"]],[30,4,[\"isLoading\"]],[30,5],true,[30,3],[28,[37,3],[[30,0,[\"trackViewedIndustryComparison\"]],2],null]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,5],[[24,0,\"qa--categorize_reports_exit\"]],[[\"@additional\",\"@onClick\",\"@size\"],[\"block\",[28,[37,3],[[30,6],false],null],\"regular\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,7],[[[1,\"    \"],[1,[28,[35,0],[\"shared_words.done\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,0],[\"authorization.sign_up_success.finish_setup\"],null]],[1,\"\\n\"]],[]]]],[]]]]]],[\"@prefix\",\"@clearSelectedCategory\",\"@socialProfile\",\"@industryReportData\",\"@sectionName\",\"@exitCategorization\",\"@isModalFlow\"],false,[\"t\",\"concat\",\"on\",\"fn\",\"shared/profile-categorization/rewards-steps/tab/hashtag-usage\",\"shared/ui/button\",\"if\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/report/partial.hbs",
    "isStrictMode": false
  });

  let PartialComponent = (_class = class PartialComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "segment", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);
    }

    trackViewedIndustryComparison(tabNum) {
      try {
        this.segment.track('viewed-industry-comparison-self-cat', {
          area: this.args.sectionName,
          user: this.auth.currentUserModel.id,
          profile: this.args.socialProfile.id,
          is_business: this.args.socialProfile.isBusiness,
          category: this.args.socialProfile.category,
          industry: this.args.socialProfile.industry,
          bus_model: this.args.socialProfile.businessModel,
          tab: tabNum === 1 ? 'engagement' : 'hashtags',
          social_profile_nickname: this.args.socialProfile.nickname
        });
      } catch (error) {
        this.errors.log(new Error(`Error Tracking viewed-industry-comparison-self-cat from location ${this.args.sectionName}`), error);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "trackViewedIndustryComparison", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackViewedIndustryComparison"), _class.prototype)), _class);
  _exports.default = PartialComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PartialComponent);
});